
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwarcabs() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Cabs',
        heading: 'Platinum24 Cabs: Pune to Mahabaleshwar Cabs',
        headingDescription: 'Platinum24 Cabs provides comfortable and affordable Pune to Mahabaleshwar Cabs, perfect for weekend getaways, family holidays, and corporate tours. Our fleet includes hatchbacks, sedans, SUVs, and luxury cars, all maintained to deliver a smooth ride through the scenic Western Ghats. With professional chauffeurs, timely pickups, and transparent pricing, we ensure your hill-station journey is safe and stress-free. Whether you’re planning sightseeing at Venna Lake, Mapro Garden, or Pratapgad Fort, Platinum24 Cabs guarantees punctual service, flexible one-way or round-trip options, and a truly enjoyable Pune to Mahabaleshwar travel experience.',

        top: 'Top Places to Visit in Mahabaleshwar with Platinum24 Cabs',

       "topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is Mahabaleshwar’s most popular attraction, offering boating, horse riding, and lakeside snacks. Surrounded by lush greenery, it is a favorite among families and couples. Evening walks along the lake are peaceful and refreshing. Street vendors serve hot corn, strawberry cream, and ice gola. In summer and monsoon, the lake becomes especially scenic. Venna Lake is Mahabaleshwar’s lively hub of leisure and charm."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat, often called the ‘Queen of Points,’ is Mahabaleshwar’s most famous viewpoint. Located at 1,470 meters, it overlooks the deep Savitri Valley and surrounding mountains. Visitors enjoy the unique rock formations resembling a natural table. The point is famous for the optical illusion where objects thrown down appear to float up. Sunsets here are mesmerizing. Arthur’s Seat is Mahabaleshwar’s signature viewpoint of wonder."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a must-visit for strawberry lovers in Mahabaleshwar. Visitors enjoy strawberry shakes, ice creams, and desserts made with fresh fruits. The garden also has a chocolate factory, food court, and nursery. During the annual Strawberry Festival, tourists can taste unlimited fruit delights. Families shop for jams, syrups, and crushes here. Mapro Garden is Mahabaleshwar’s sweet paradise of flavors."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, built by Chhatrapati Shivaji Maharaj in 1656, is a historic hill fort near Mahabaleshwar. It is famous for the battle between Shivaji Maharaj and Afzal Khan. The fort’s bastions, temples, and watchtowers narrate Maratha bravery. Trekking to the fort offers scenic views of valleys and forests. It is also a pilgrimage site with Bhavani Mata Temple. Pratapgad is Mahabaleshwar’s proud heritage landmark."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a fascinating rock formation resembling an elephant’s trunk. Located near Lodwick Point, it offers panoramic valley views. The natural arch-shaped rock makes it a favorite among photographers. Misty monsoon weather adds a magical vibe to the spot. Tourists enjoy peaceful moments surrounded by greenery. Elephant’s Head Point is Mahabaleshwar’s unique natural wonder."
  },
  {
    "title": "Wilson Point",
    "description": "Wilson Point, also known as Sunrise Point, is the highest point in Mahabaleshwar at 1,439 meters. It offers breathtaking views of sunrise and the surrounding valleys. The point has three watch towers giving panoramic sights of the Sahyadris. It is popular among photographers and nature enthusiasts. Clear skies provide excellent stargazing opportunities at night. Wilson Point is Mahabaleshwar’s scenic crown."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a spectacular cascade located between Mahabaleshwar and Panchgani. The main fall drops from 600 feet, creating a stunning sight, especially in monsoon. Visitors can enjoy smaller waterfalls nearby for safe splashing. The viewpoint offers breathtaking valley panoramas. It is a favorite for trekking and photography. Lingmala Waterfall is Mahabaleshwar’s natural jewel of the rainy season."
  },
  {
    "title": "Kate’s Point & Needle Hole Point",
    "description": "Kate’s Point and nearby Needle Hole Point offer stunning views of the Krishna Valley and Dhom Dam. The unique rock formation with a hole resembling a needle makes it fascinating. Tourists love capturing scenic landscapes from here. The cool breeze and misty environment enhance the experience. It is one of the best picnic and photography spots in Mahabaleshwar. Kate’s Point is the hill station’s panoramic window."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The ancient Mahabaleshwar Temple, dedicated to Lord Shiva, is one of the most sacred sites in the region. Built in the 16th century, it houses the Atma Linga and a 500-year-old Shiva idol. Pilgrims visit year-round, especially during Mahashivratri. The temple’s Hemadpanthi architecture adds to its charm. Surrounded by hills, it offers a peaceful spiritual retreat. Mahabaleshwar Temple is the town’s sacred heritage soul."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description": "Tapola, often called Mini Kashmir, is a tranquil lake destination 25 km from Mahabaleshwar. Surrounded by forests and hills, it is perfect for boating, kayaking, and camping. The Shivsagar Lake here stretches for miles, offering serene views. Adventure lovers enjoy trekking and nature trails nearby. It is a hidden gem for peaceful weekend getaways. Tapola is Mahabaleshwar’s offbeat paradise of serenity."
  }
],



    "services": [
    {
      "name": "Pune to Mahabaleshwar Cab Booking",
      "description": "Seamless cab booking service from Pune to Mahabaleshwar that offers easy online reservations, instant confirmations, and flexible payment options. Perfect for tourists and locals planning a trip to the scenic hill station."
    },
    {
      "name": "Taxi from Pune to Mahabaleshwar",
      "description": "Reliable taxi service from Pune to Mahabaleshwar providing comfortable rides with experienced drivers. Ideal for solo travelers, families, and groups looking for safe and timely transportation to the hill station."
    },
    {
      "name": "Pune to Mahabaleshwar Car Hire",
      "description": "Flexible car hire options for the Pune to Mahabaleshwar route, including self-drive and chauffeur-driven vehicles. Choose from a variety of cars suited for all budgets and preferences for your getaway."
    },
    {
      "name": "Pune to Mahabaleshwar taxi service",
      "description": "Dedicated taxi service connecting Pune and Mahabaleshwar with a focus on punctuality, comfort, and customer satisfaction. Our drivers are well-versed with the routes and ensure a pleasant travel experience."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Rental",
      "description": "Comprehensive cab rental service from Pune to Mahabaleshwar offering hourly and daily rental packages. Perfect for tourists wanting to explore multiple destinations within the region with hassle-free transportation."
    },
    {
      "name": "Pune to Mahabaleshwar Elphinstone Point Car",
      "description": "Specialized cab service to Elphinstone Point from Pune via Mahabaleshwar. Enjoy a comfortable ride to this famous viewpoint with knowledgeable drivers who can guide you on the best spots and timings."
    },
    {
      "name": "Pune to Mahabaleshwar Pratapgad Fort car",
      "description": "Taxi service from Pune to Pratapgad Fort via Mahabaleshwar, ideal for history enthusiasts and tourists. Travel comfortably with expert drivers who ensure timely drop-offs and pickups to explore this historic site."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Price",
      "description": "Transparent and competitive pricing for cabs from Pune to Mahabaleshwar, with no hidden charges. Choose from budget, premium, and luxury vehicles tailored to your travel needs and budget."
    },
    {
      "name": "Pune to Mahabaleshwar 2 days taxi fare",
      "description": "Affordable and value-for-money 2-day taxi packages from Pune to Mahabaleshwar, including sightseeing tours and comfortable overnight stays. Perfect for weekend travelers wanting to explore the region at leisure."
    },
    {
      "name": "Book cab from Pune to Mahabaleshwar",
      "description": "Quick and hassle-free online booking service to reserve your cab from Pune to Mahabaleshwar with instant confirmation and customer support. Plan your trip with ease and confidence."
    },
    {
      "name": "Pune to Mahabaleshwar Cabs",
      "description": "Trusted cab services operating between Pune and Mahabaleshwar offering a fleet of well-maintained vehicles and experienced drivers to ensure a safe and enjoyable journey to the popular hill station."
    }
  ],
  "tableData": [
    ["Pune to Mahabaleshwar Cab Booking", "Taxi from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Car Hire", "Pune to Mahabaleshwar taxi service"],
    ["Pune to Mahabaleshwar Cab Rental", "Pune to Mahabaleshwar Elphinstone Point Car"],
    ["Pune to Mahabaleshwar Pratapgad Fort car", "Pune to Mahabaleshwar Cab Price"],
    ["Pune to Mahabaleshwar 2 days taxi fare", "Book cab from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Cabs"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Mahabaleshwar Cabs for Scenic Travel",
        "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly and comfortable cab services for your Pune to Mahabaleshwar journey."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Hill Station Trips",
        "WhyChoosedescription": "Enjoy a relaxing ride in our well-maintained cabs, perfect for the winding roads to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We prioritize hygiene by regularly cleaning and sanitizing our vehicles before every trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers Skilled in Hill Routes",
        "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Mahabaleshwar route, ensuring a safe and smooth journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Choose from customizable packages that fit your travel plans to and from Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "Benefit from clear, all-inclusive pricing covering fuel, tolls, and driver allowances."
    },
    {
        "WhyChooseheading": "Perfect for Family Outings, Weekend Getaways, and Group Tours",
        "WhyChoosedescription": "Our cabs are ideal for personal trips, group travel, and leisure excursions to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, itinerary changes, and special requests."
    }
]













    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services from Pune to Mahabaleshwar?',
        answer: 'Yes, Platinum24 Cabs provides comfortable and reliable cab services for travel between Pune and Mahabaleshwar.',
    },
    {
        question: 'How can I book a Pune to Mahabaleshwar cab with Platinum24 Cabs?',
        answer: 'You can book your Pune to Mahabaleshwar cab easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Mahabaleshwar trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your comfort and budget.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Mahabaleshwar?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Mahabaleshwar route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Mahabaleshwar?',
        answer: 'Absolutely! We provide round-trip cab options with flexible scheduling to fit your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Mahabaleshwar cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Mahabaleshwar rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Mahabaleshwar route.',
    },
    {
        question: 'Are safety measures in place for Pune to Mahabaleshwar cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for a safe and comfortable journey.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Mahabaleshwar travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Mahabaleshwar?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Mahabaleshwar routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Patil',
        feedback: 'The cab service from Pune to Mahabaleshwar by Platinum24 Cabs was excellent. The driver was friendly and the ride very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priyanka Desai',
        feedback: 'I had a wonderful trip to Mahabaleshwar with Platinum24 Cabs. The booking process was easy and the car was in great condition.',
        rating: 5,
    },
];






























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToMahabaleshwarCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-mahabaleshwar-cab.jpg",
  "description": "Book comfortable and reliable Pune to Mahabaleshwar cabs with Platinum24 Cabs. Ideal for sightseeing trips to Elphinstone Point, Pratapgad Fort, and more. Affordable fares with trusted drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "17200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-mahabaleshwar-cabs"
  }
};








    return (
        <div>
<Helmet>
  <title>Pune to Mahabaleshwar Cabs | Sightseeing & Taxi Service | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book comfortable and reliable Pune to Mahabaleshwar cabs with Platinum24 Cabs. Ideal for sightseeing trips to Elphinstone Point, Pratapgad Fort, and more. Affordable fares with trusted drivers."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Cab Booking, Taxi from Pune to Mahabaleshwar, Pune to Mahabaleshwar Car Hire, Pune to Mahabaleshwar taxi service, Pune to Mahabaleshwar Cab Rental, Pune to Mahabaleshwar Elphinstone Point Car, Pune to Mahabaleshwar Pratapgad Fort car, Pune to Mahabaleshwar Cab Price, Pune to Mahabaleshwar 2 days taxi fare, Book cab from Pune to Mahabaleshwar, Pune to Mahabaleshwar Cabs"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToMahabaleshwarCabsSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwarcabs;